import { render, staticRenderFns } from "./NavbarItems.vue?vue&type=template&id=631a4d7f&scoped=true"
import script from "./NavbarItems.vue?vue&type=script&lang=js"
export * from "./NavbarItems.vue?vue&type=script&lang=js"
import style0 from "./NavbarItems.vue?vue&type=style&index=0&id=631a4d7f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631a4d7f",
  null
  
)

export default component.exports